import { createAction } from '@reduxjs/toolkit';

export const updateOpenRoutes = createAction('updateOpenRoutes', (params) => ({
  payload: params,
}));

export const toggleDevMode = createAction('toggleDevMode');

// 401 Unauthorized modal controls
export const openUnauthorizedModal = createAction('global/openUnauthorizedModal');
export const closeUnauthorizedModal = createAction('global/closeUnauthorizedModal');
